import { useLoaderData } from "react-router-dom" 
import type { LoaderFunctionArgs } from "react-router-dom";
import { formatDate, formatTime } from "../../functions/formatDate";
import Markdown from "react-markdown"

export async function loader({params}: LoaderFunctionArgs): Promise<Event | null> {
    const response = await fetch(`${import.meta.env.VITE_API_URL}/events/${params.eventID}`)
    console.log(response)
    const event: Event = await response.json()
    return event
    
}
export default function EventSingle() {

    const [item] = useLoaderData();

    return <>
        <div className="container body-text">
            <img className="details-image" src={`${import.meta.env.VITE_API_URL}/uploads/${item.image}`} />
            <div className="details-top">
                <h1 className="details-title">{item.title}</h1>
                <p className="details-time">{formatDate(item.date).toUpperCase()} {formatTime(item.time)}</p>
                <p className="details-location">{item.location.toUpperCase()}</p>
                <p className="details-cost">{item.cost.toUpperCase()}</p>
            </div>
            <div className="details-details">
                <Markdown>{item.details}</Markdown>
            </div>
            
        </div>
    </>
}